'use strict';
const assert = require('assert');
const ParamsManager = require('../params-manager');
const chai = require('chai');

const expect = chai.expect;
/* eslint-disable  no-undef */ /* eslint-disable  no-unused-vars */
describe('ParamsManager', () => {
  it('Creates the correct instance of the class with no parameters', (done) => {
    try {
      const paramsManager = new ParamsManager();
      expect(paramsManager).to.have.property('pathParams');
      expect(paramsManager).to.have.property('bodyParams');
      expect(paramsManager).to.have.property('queryParams');
      done();
    } catch (error) {
      assert(false);
      done();
    }
  });
  it('Creates the correct instance of the class with parameters', (done) => {
    const paramsManager = new ParamsManager(['pathParam'], { body: 'param' }, [{ query: 'param' }]);
    expect(paramsManager).to.have.property('pathParams');
    expect(paramsManager).to.have.property('bodyParams');
    expect(paramsManager).to.have.property('queryParams');
    assert(paramsManager.pathParams[0] === 'pathParam');
    assert(paramsManager.bodyParams.body === 'param');
    assert(paramsManager.queryParams[0].query === 'param');
    done();
  });
  it('addPathParams, adds the param to the array', (done) => {
    const paramsManager = new ParamsManager();
    paramsManager.addPathParam('addedParam');
    expect(paramsManager).to.have.property('pathParams');
    assert(paramsManager.pathParams[0] === 'addedParam');
    done();
  });
  it('addPathParams, if nothing is added return an error', (done) => {
    const paramsManager = new ParamsManager();
    try {
      paramsManager.addPathParam();
    } catch (error) {
      assert(error.message === 'Pass a param to the addPathParam function');
      done();
    }
  });
  it('addPathParams, it is not possible to pass an array or an object', (done) => {
    const paramsManager = new ParamsManager();
    try {
      paramsManager.addPathParam(['param']);
    } catch (error) {
      assert(error.message === 'The param can not be an object or an array');
      done();
    }
  });
  it('getPathParams, return pathParams', (done) => {
    const paramsManager = new ParamsManager();
    paramsManager.addPathParam('param');
    expect(paramsManager.getPathParams()[0]).to.equal('param');
    done();
  });
  it('addBodyParams, it is not possible to pass variable diferent than an array or an object', (done) => {
    const paramsManager = new ParamsManager();
    try {
      paramsManager.addBodyParams('param');
    } catch (error) {
      assert(error.message === 'bodyParams must be an object');
      done();
    }
  });
  it('getBodyParams, return bodyParams', (done) => {
    const paramsManager = new ParamsManager();
    paramsManager.addBodyParams({ param: 'param' });
    expect(paramsManager.getBodyParams()).to.have.property('param');
    done();
  });
  it('addQueryParam, there must be only objects inside the args array', (done) => {
    const paramsManager = new ParamsManager();
    try {
      paramsManager.addQueryParam({ teste: 'rino' }, 'rekt');
    } catch (error) {
      assert(error.message === 'queryParam must be inside an object');
      done();
    }
  });
  it('getBodyParams, return bodyParams', (done) => {
    const paramsManager = new ParamsManager();
    paramsManager.addQueryParam({ teste: 'rino' }, { another: 'value' });
    expect(paramsManager.getQueryParams()[0]).to.have.property('teste');
    expect(paramsManager.getQueryParams()[1]).to.have.property('another');
    assert(paramsManager.getQueryParams()[0].teste === 'rino');
    assert(paramsManager.getQueryParams()[1].another === 'value');
    done();
  });
  it('getRequestParams, returns pathParams, bodyParams and queryParams', (done) => {
    const paramsManager = new ParamsManager(['patherino'], { body: 'bodyrino' }, [{ query: 'ino' }]);
    expect(paramsManager.getRequestParams()).to.have.property('pathParams');
    expect(paramsManager.getRequestParams()).to.have.property('bodyParams');
    expect(paramsManager.getRequestParams()).to.have.property('queryParams');
    assert(paramsManager.getRequestParams().pathParams[0] === 'patherino');
    assert(paramsManager.getRequestParams().bodyParams.body === 'bodyrino');
    assert(paramsManager.getRequestParams().queryParams[0].query === 'ino');
    done();
  });
});
